import { ContentArea } from 'components/content-area';
import React from 'react';

interface Props {
  children?: React.ReactNode;
}

const VirtualMachineControlPanel = (props: Props) => {
  return (
    <ContentArea>
      <h1>Virtual machine</h1>
      {props.children}
    </ContentArea>
  );
};

export default VirtualMachineControlPanel;
